<div class="calendar-header-container">
  <div class="loading-container">
    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  </div>

  <section class="calendar-header">
    <!-- Display current week, click to open date picker -->
    <div class="calendar-header-selected-date" (click)="jumpToDatePicker.open()">
      <h2 class="link link--noline">
        <!-- Month display -->
        <ng-container *ngIf="!(firstOfWeek && lastOfWeek)">
          <span>{{focusDate | date:'LLLL yyyy'}}</span>
        </ng-container>
        <!-- Week display -->
        <ng-container *ngIf="firstOfWeek && lastOfWeek">
          <!-- Desktop: Show full month name -->
          <span class="md-month-display">
            {{ formatDateRange(firstOfWeek, lastOfWeek, true, true) }}
          </span>
          <!-- Tablet: Abbreviate month name -->
          <span class="sm-month-display">
            {{ formatDateRange(firstOfWeek, lastOfWeek, false, true) }}
          </span>
          <!-- Mobile: Abbreviate month name & remove year -->
          <span class="xs-month-display">
            {{ formatDateRange(firstOfWeek, lastOfWeek, false, false) }}
          </span>
        </ng-container>
      </h2>
      <!-- Hidden input for selected date (ensures datepicker appears in correct position) -->
      <input matInput [value]="focusDate" [matDatepicker]="jumpToDatePicker" (focus)="jumpToDatePicker.open()"
        (dateChange)="selectedDateChanged($event.value)">
      <mat-datepicker #jumpToDatePicker [dateClass]="dateClass" (monthSelected)="monthSelected($event)" startView="year"
        panelClass="calendar-header-datepicker"></mat-datepicker>
    </div>

    <section class="calendar-header-selectors">
      <a id="previous-month-selector" (click)="prev.emit()" class="link link--noline">
        <i class="fa-solid fa-chevron-left"></i>
      </a>
      <a id="today-btn" (click)="selectedDateChanged()" class="link link--noline">Today</a>
      <a id="next-month-selector" (click)="next.emit()" class="link link--noline">
        <i class="fa-solid fa-chevron-right"></i>
      </a>
    </section>
  </section>
</div>
